import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useFacilityShowLessonPrices_facility$key } from "./__generated__/useFacilityShowLessonPrices_facility.graphql";

export const useFacilityShowLessonPrices = (
  facilityRef: useFacilityShowLessonPrices_facility$key | null
) => {
  const facility = useFragment(
    useFacilityShowLessonPricesFragmentString,
    facilityRef
  );
  const supportsPublic = !!facility?.club?.supportsPublic;

  return supportsPublic
    ? !!facility?.publicLessonsPermissionSet?.showPrices
    : !!facility?.privateLessonsPermissionSet?.showPrices;
};

const useFacilityShowLessonPricesFragmentString = graphql`
  fragment useFacilityShowLessonPrices_facility on Facility {
    club {
      supportsPublic
    }
    publicLessonsPermissionSet {
      showPrices
    }
    privateLessonsPermissionSet {
      showPrices
    }
  }
`;
